import React from 'react';

import { redirectUrlFunction } from '../CommonUtilityServices/RedirectService';
import WorkflowCard from './WorkflowCard';

export const handleQuickQuoteRedirect = () =>
  redirectUrlFunction(
    {
      Area: 'Relate Quick Quote',
      DetailedContext: [
        {
          name: 'quoteType',
          value: 'QuickQuote',
        },
      ],
      TypeOfRedirect: 'Relate Quick Quote',
    },
    'POST',
    null,
    () => {},
    () => {},
  );

const WorkflowCardQuickQuote = () => {
  const handleOnClick = handleQuickQuoteRedirect;

  return (
    <WorkflowCard
      onClick={handleOnClick}
      icon={'icons-icon-request-quote'}
      title="Quick Quote"
      description="Start a quick quote for your client's insurance needs."
    />
  );
};

export default WorkflowCardQuickQuote;
